/**
 * Add-on Product Notice
 * Displays an alert message on lens insert product pages
 * Letting customers know these are add-on only products
 */
(function() {
  'use strict';

  // Products that should show the add-on notice
  const ADDON_ONLY_PRODUCTS = [
    'lens-insert-prescription',
    'lens-insert-clear'
  ];

  function init() {
    // Check if we're on a product page for an add-on only product
    const currentPath = window.location.pathname;
    const isAddonProduct = ADDON_ONLY_PRODUCTS.some(handle => 
      currentPath.includes(`/products/${handle}`)
    );

    if (!isAddonProduct) return;

    console.log('[Addon Notice] Add-on only product detected');

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addNotice);
    } else {
      addNotice();
    }
  }

  function addNotice() {
    // Don't add if already exists
    if (document.getElementById('addon-product-notice')) return;

    // Find the product title
    const titleSelectors = [
      '.product__title',
      '.product-single__title',
      'h1.product-title',
      '[data-product-title]',
      '.product-info h1',
      'h1'
    ];

    let titleElement = null;
    for (const selector of titleSelectors) {
      titleElement = document.querySelector(selector);
      if (titleElement) break;
    }

    if (!titleElement) {
      console.warn('[Addon Notice] Could not find product title element');
      return;
    }

    // Create the notice element
    const notice = document.createElement('div');
    notice.id = 'addon-product-notice';
    notice.innerHTML = `
      <div class="addon-notice-content">
        <div class="addon-notice-icon">ℹ️</div>
        <div class="addon-notice-text">
          <strong>Add-On Product Only</strong>
          <p>This lens insert is designed to be purchased as an <strong>add-on</strong> with compatible Glider or Mini Strider sunglasses. It will be automatically offered when you add compatible sunglasses to your cart.</p>
          <a href="/collections/performance" class="addon-notice-link">
            Shop Compatible Sunglasses →
          </a>
        </div>
      </div>
    `;

    // Add styles
    const styles = document.createElement('style');
    styles.textContent = `
      #addon-product-notice {
        margin: 16px 0 24px 0;
        padding: 20px;
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border: 2px solid #f59e0b;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
      }

      .addon-notice-content {
        display: flex;
        align-items: flex-start;
        gap: 16px;
      }

      .addon-notice-icon {
        font-size: 2em;
        line-height: 1;
        flex-shrink: 0;
      }

      .addon-notice-text {
        flex: 1;
      }

      .addon-notice-text strong {
        display: block;
        font-size: 1.1em;
        color: #92400e;
        margin-bottom: 8px;
      }

      .addon-notice-text p {
        margin: 0 0 12px 0;
        color: #78350f;
        font-size: 0.95em;
        line-height: 1.5;
      }

      .addon-notice-link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #f59e0b;
        color: white !important;
        padding: 10px 20px;
        border-radius: 8px;
        text-decoration: none !important;
        font-weight: 600;
        font-size: 0.95em;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
      }

      .addon-notice-link:hover {
        background: #d97706;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
      }

      .addon-notice-link:active {
        transform: translateY(0);
      }

      @media (max-width: 600px) {
        #addon-product-notice {
          padding: 16px;
        }

        .addon-notice-content {
          flex-direction: column;
          gap: 12px;
        }

        .addon-notice-icon {
          font-size: 1.5em;
        }

        .addon-notice-link {
          width: 100%;
          justify-content: center;
        }
      }
    `;

    // Insert the notice after the title
    titleElement.parentNode.insertBefore(notice, titleElement.nextSibling);
    document.head.appendChild(styles);

    console.log('[Addon Notice] Notice added successfully');
  }

  // Initialize
  init();
})();

